var exports = {
  "Y": "xcc377c0b--b86294--tooltip",
};

module.exports = exports;
